import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MUITableContainer(theme: Theme): Components['MuiTableContainer'] {
  return {
    styleOverrides: {
      root: {
        overflow: 'hidden',
        boxShadow: theme.shadows[3],
        borderRadius: theme.shape.borderRadius,
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
    },
  };
}
